module.exports = __webpack_public_path__ + "static/media/5TheHiddenWorldOfTheNationalParks.3e1210d2.JPG";